/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import { get } from 'lodash';
import { Rnd } from 'react-rnd';
import { Box, Modal, Stack, Grid, Button, Tooltip } from '@mui/material';
import { closeIconBlack } from '../../shared/assets/images';
import { defaultModalOptions } from '../../shared/constantVariable';
import Notification from '../../shared/notification-modal';
import { saveFormDataInLocalStorage } from '../../shared/feed-common-feature';
import { getBorderColor } from '../../shared/utils';
import { convertUnitValues_flow, convertUnitValues_pressure } from '../../shared/conversion-helper/unitConversion';
import './pump.scss';

const checkFlowUnit = {};
const checkPressureUnit = {};
const previousPressureUnit_pump = {};

const PumpInput = (props) => {

  const { visiblePump, handleClosePump, pumpDetails, translateObject, setokbuttonFormAutoSave } = props;
  const [modalOption, setModalOption] = useState(defaultModalOptions);

  const [disabled, setDisabled] = useState(true);
  const units = JSON.parse(localStorage.getItem('system-units')) || JSON.parse(localStorage.getItem('unit_set_dict')) || {};
  const previous_units = JSON.parse(localStorage.getItem('previous_units')) || {};
  const defaultVals = {
    flowrate: 0.0,
    discharge_pressure: 0.000,
    inlet_pressure: 0.00,
    power: 0.00,
    auto_checked: true,
    pump_efficiency: 75,
    motor_efficiency: 96,
    vfd_efficiency: 97
  };

  const [inputState, setInputState] = useState(defaultVals);
  const [isShowErrorMessage, setIsShowErrorMessage] = useState(false);

  const fetchData = () => {
    const defaultVals = {
      flowrate: 0.0,
      discharge_pressure: 0.000,
      inlet_pressure: 0.00,
      power: 0.00,
      auto_checked: true,
      pump_efficiency: 75,
      motor_efficiency: 96,
      vfd_efficiency: 97
    };
    let previous_pressure_unit = 'atm';
    if (localStorage.getItem('previous_pressure_unit')) {
      previous_pressure_unit = localStorage.getItem('previous_pressure_unit');
    }
    checkPressureUnit[pumpDetails.id] = units.pressure ? units.pressure : 'atm';
    previous_pressure_unit = checkPressureUnit[pumpDetails.id];
    if (previousPressureUnit_pump[pumpDetails.id]) {
      previous_pressure_unit = previousPressureUnit_pump[pumpDetails.id];
    }
    if (localStorage.getItem('pump-dict') && localStorage.getItem('pump-dict') !== '{}') {
      const formData_pump = JSON.parse(localStorage.getItem('pump-dict'));
      const storageData = formData_pump.pump[`${pumpDetails.id}`] || {};

      if (checkPressureUnit[pumpDetails.id] && checkPressureUnit[pumpDetails.id] !== previous_pressure_unit) {
        storageData.discharge_pressure = parseFloat(convertUnitValues_pressure(storageData.discharge_pressure, previous_pressure_unit, units.pressure ? units.pressure : 'atm'));
      }

      const formData_pump_1 = JSON.parse(localStorage.getItem('ro_ouput_data'));
      if (formData_pump_1 && formData_pump.pump[`${pumpDetails.id}`]) {
        const unitop_name = localStorage.getItem(pumpDetails.id);
        if (formData_pump_1[unitop_name]) {
          storageData.flowrate = formData_pump_1[unitop_name].output_user.flow;
          storageData.inlet_pressure = formData_pump_1[unitop_name].output_user.inlet_pressure;
          storageData.power = formData_pump_1[unitop_name].output_user.hp;
          storageData.pump_efficiency = formData_pump_1[unitop_name].output_user.pump_efficiency.toFixed(2);
          // convert the flowrate, inlet_pressure and power value if user making any changes from system unit form -- START
          if (Object.keys(previous_units).length) {
            if (previous_units['Volume Flow'] !== units.flow) {
              storageData.flowrate = parseFloat(convertUnitValues_flow(formData_pump_1[unitop_name].output_user.flow, previous_units['Volume Flow'], units.flow));
            }
            if (previous_units.Pressure !== units.pressure) {
              storageData.inlet_pressure = parseFloat(convertUnitValues_pressure(formData_pump_1[unitop_name].output_user.inlet_pressure, previous_units.Pressure, units.pressure));
            }
            if (previous_units.Power !== units.power) {
              storageData.power = parseFloat(convertUnitValues_flow(formData_pump_1[unitop_name].output_user.hp, previous_units.Power, units.power));
            }
          }
          // convert the flowrate, inlet_pressure and power value if user making any changes from system unit form -- END
        }
      }
      else {
        setInputState(defaultVals);
      }

      if (Object.keys(storageData).length > 0) {
        setInputState(storageData);
        setDisabled(storageData.auto_checked);
      } else {
        setInputState(defaultVals);
      }
    }
    previousPressureUnit_pump[pumpDetails.id] = checkPressureUnit[pumpDetails.id];
  };

  useEffect(() => {
    fetchData();
  }, []);

  const checkValue = (e) => {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');
    if (e.target.checked === true) {
      setDisabled(e.target.checked);
      inputState.auto_checked = true;
    } else {
      setDisabled(false);
      inputState.auto_checked = false;
    }
  };

  const getPumpName = () => {
    let pumpName = '';
    const local = localStorage.getItem(pumpDetails.id);
    if (local) {
      pumpName = ` - ${local}`;
    } else {
      pumpName = ` - Pump ${Number(get(pumpDetails, 'id', '').split('_')[1]) + 1}`;
    }
    return pumpName;
  };

  const handleInputChange = e => {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');
    setInputState({
      ...inputState,
      [e.target.name]: Number(e.target.value),
    });
  };

  function getUnitValue(item, value) {
    if (item === 'Pressure') {
      return units.pressure || value;
    } if (item === 'Flow') {
      return units.flow || value;
    }
  }

  const submitForm = () => {
    saveFormDataInLocalStorage({ record: inputState, type: 'pump', id: pumpDetails.id, item: 'pump-dict' });
    checkFlowUnit[pumpDetails.id] = units.flow;
    checkPressureUnit[pumpDetails.id] = units.pressure;
    getBorderColor(pumpDetails.id);
    setokbuttonFormAutoSave(true);
    handleClosePump();
    if (isShowErrorMessage) {
      localStorage.setItem('globalExitBtn', 'true');
    }
  };

  const handleClose_Pump = () => {
    if (isShowErrorMessage) {
      localStorage.setItem('globalExitBtn', 'true');
    }
    handleClosePump();
  };

  const handleClosePumpModal = () => {
    if (isShowErrorMessage) {
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        message: translateObject('Are you sure you want to close this form?'),
        onYes: () => handleClose_Pump(),
        onNo: () => setModalOption(defaultModalOptions)
      });
    } else {
      handleClosePump();
    };
  };

  return (
    <Modal
      hideBackdrop
      open={visiblePump}
      onClose={handleClosePumpModal}
      className="splitter-modal"
    >
      <Box>
        <Rnd
          default={{
            width: '40%',
            x: ((window.innerWidth / 2) - ((40 * (window.innerWidth / 100)) / 2)),
            y: ((window.innerHeight / 2) - ((45 * (window.innerHeight / 100)) / 2)),
          }}
          enableResizing={{
            bottom: false, bottomLeft: false, bottomRight: false,
            left: true, right: true,
            top: false, topLeft: false, topRight: false
          }}
          allowAnyClick
          enableUserSelectHack={false}
          resizeHandleStyles={{ 'right': { 'width': '5px' } }} // reducing width of right handle to 5px ---> kranthi
          minWidth='25%'
          cancel='.no_drag'
          className='pump-box'>
          <Notification
            options={modalOption}
            handleClose={() => setModalOption(defaultModalOptions)}
          />
          <Grid container className='pump-grid-container'>
            <Grid item xs={12} className='pump-header-grid'>
              <div className='pump-header-text no_drag rufusBld S_heading forground-text-primary'>{`Pump Specification ${getPumpName()}`}</div>
              <div className='pump-close-icon no_drag'>
                <Tooltip title="Close">
                  <img
                    src={closeIconBlack}
                    alt="close"
                    onClick={handleClosePumpModal}
                    style={{ width: '14px', padding: '11px' }}
                    className="pointer"
                  />
                </Tooltip>
              </div>
            </Grid>
            <Grid item xs={12} spacing={2} className='pump-body-container sansW4SeLig'>
              <Grid container xs={12} spacing={2} style={{ margin: '12px 0px 0px 0px', padding: '0px 20px' }}>
                <Grid container xs={12} md={12} sm={12} className='pump-field-design' style={{ padding: '5px', display: 'flex', alignItems: 'center' }}>
                  <Grid item xs={5} md={5} sm={12}>
                    <div className="normal-font f-left ml-2 no_drag S_Bold">{translateObject('Flow Rate')}</div>
                  </Grid>
                  <Grid item xs={7} md={7} sm={12}>
                    <Grid container>
                      <Grid item xs={9}>
                        <div className='pump-textbox no_drag '>
                          <input type="text" id="cancel-handle" className='Form_Input_design' name="flowrate" value={parseFloat(inputState.flowrate).toFixed(1)}
                            onChange={handleInputChange} onFocus={e => e.target.select()} disabled />
                        </div>
                      </Grid>
                      <div className='pump-filed-units'>
                        <div className='no_drag Form_Input_design_Units'>{getUnitValue('Flow', 'gpm')}</div>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container xs={12} md={12} sm={12} className='pump-field-design' style={{ padding: '5px', display: 'flex', alignItems: 'center' }}>
                  <Grid item xs={5} md={5} sm={12}>
                    <div className="normal-font f-left ml-2 no_drag S_Bold">{translateObject('Discharge Pressure')}</div>
                  </Grid>
                  <Grid item xs={7} md={7} sm={12}>
                    <Grid container>
                      <Grid item xs={9}>
                        <div className='pump-textbox no_drag'>
                          <input type="number" id="handle-cancel" className='Form_Input_design' name="discharge_pressure" value={parseFloat(inputState.discharge_pressure)}
                            onChange={handleInputChange} onFocus={e => e.target.select()}
                            style={{ paddingLeft: '8px', width: '100%' }} />
                        </div>
                      </Grid>
                      <div className='pump-filed-units'>
                        <div className='no_drag Form_Input_design_Units'>{getUnitValue('Pressure', 'atm')}</div>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container xs={12} md={12} sm={12} className='pump-field-design' style={{ padding: '5px', display: 'flex', alignItems: 'center' }}>
                  <Grid item xs={5} md={5} sm={12}>
                    <div className="normal-font f-left ml-2 no_drag S_Bold">{translateObject('Inlet Pressure')}</div>
                  </Grid>
                  <Grid item xs={7} md={7} sm={12}>
                    <Grid container>
                      <Grid item xs={9}>
                        <div className='pump-textbox no_drag'>
                          <input type="text" id="handle-cancel" className='Form_Input_design' name="inlet_pressure" value={parseFloat(inputState.inlet_pressure).toFixed(2)}
                            onChange={handleInputChange} onFocus={e => e.target.select()} disabled />
                        </div>
                      </Grid>
                      <div className='pump-filed-units'>
                        <div className='no_drag Form_Input_design_Units'>{getUnitValue('Pressure', 'atm')}</div>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container xs={12} md={12} sm={12} className='pump-field-design' style={{ padding: '5px', display: 'flex', alignItems: 'center' }}>
                  <Grid item xs={5}>
                    <div className="normal-font f-left ml-2 no_drag S_Bold">{translateObject('Power')}</div>
                  </Grid>
                  <Grid item xs={7} style={{ display: 'flex', alignItems: 'center' }}>
                    <div className='pump-textbox no_drag sansW4SeLig L_Regular forground-text-primary'>
                      <div className='no_drag'>{parseFloat(inputState.power).toFixed(2)} kW</div>
                    </div>
                  </Grid>
                </Grid>
                <Grid container xs={12} md={12} sm={12} className='pump-field-design' style={{ padding: '5px', display: 'flex', alignItems: 'center' }}>
                  <Grid item xs={5}>
                    <div className="normal-font f-left ml-2 no_drag S_Bold">{translateObject('Auto Efficiencies')}</div>
                  </Grid>
                  <Grid item xs={7}>
                    <div className='pump-textbox sansW4SeLig'>
                      <input id="box2" className='no_drag' onChange={checkValue} onFocus={e => e.target.select()}
                        type="checkbox" value="Box2" checked={disabled} />
                    </div>
                  </Grid>
                </Grid>
                <Grid container xs={12} md={12} sm={12} className='pump-field-design' style={{ padding: '5px', display: 'flex', alignItems: 'center' }}>
                  <Grid item xs={5} md={5} sm={12} >
                    <div className="normal-font f-left ml-2 no_drag S_Bold">{translateObject('Pump Efficiency')}</div>
                  </Grid>
                  <Grid item xs={7} md={7} sm={12} >
                    <Grid container>
                      <Grid item xs={9}>
                        <div className='pump-textbox no_drag sansW4SeLig'>
                          <input type="text" id="handle-cancel" className='Form_Input_design' name="pump_efficiency" value={inputState.pump_efficiency}
                            onChange={handleInputChange} onFocus={e => e.target.select()} disabled={disabled} />
                        </div>
                      </Grid>
                      <div className='pump-filed-units'>
                        <div className='no_drag Form_Input_design_Units'>%</div>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container xs={12} md={12} sm={12} className='pump-field-design' style={{ padding: '5px', display: 'flex', alignItems: 'center' }}>
                  <Grid item xs={5} md={5} sm={12}>
                    <div className="normal-font f-left ml-2 no_drag S_Bold">{translateObject('Motor Efficiency')}</div>
                  </Grid>
                  <Grid item xs={7} md={7} sm={12}>
                    <Grid container>
                      <Grid item xs={9}>
                        <div className='pump-textbox no_drag sansW4SeLig'>
                          <input type="text" id="handle-cancel" name="motor_efficiency" className='Form_Input_design' value={inputState.motor_efficiency}
                            onChange={handleInputChange} onFocus={e => e.target.select()} disabled={disabled} />
                        </div>
                      </Grid>
                      <div className='pump-filed-units'>
                        <div className='no_drag Form_Input_design_Units'>%</div>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container xs={12} md={12} sm={12} className='pump-field-design' style={{ padding: '5px', display: 'flex', alignItems: 'center' }}>
                  <Grid item xs={5} md={5} sm={12}>
                    <div className="normal-font f-left ml-2 no_drag S_Bold">{translateObject('VFD Efficiency')}</div>
                  </Grid>
                  <Grid item xs={7} md={7} sm={12}>
                    <Grid container>
                      <Grid item xs={9}>
                        <div className='pump-textbox no_drag sansW4SeLig'>
                          <input type="text" id="handle-cancel" name="vfd_efficiency" className='Form_Input_design' value={inputState.vfd_efficiency}
                            onChange={handleInputChange} onFocus={e => e.target.select()} disabled={disabled} />
                        </div>
                      </Grid>
                      <div className='pump-filed-units'>
                        <div className='no_drag Form_Input_design_Units'>%</div>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={12} sm={12}>
                <div className="pump-button">
                  <Stack spacing={2} direction="row">
                    <Button variant="contained" size="small" className="sansW4SeLig M_Bold Secondary-Default_button"
                      style={{ border: 'none' }}
                      onClick={handleClosePumpModal}>{translateObject('Cancel')}</Button>
                    <Button variant="contained" size="small" className="sansW4SeLig M_Bold Primary_Default_Button"
                      onClick={submitForm}>{translateObject('OK')}</Button>
                  </Stack>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Rnd>
      </Box>
    </Modal>
  );
};
export default PumpInput;
